import { StoryblokAsset } from "../../../interfaces/StoryblokAsset.interface";

const getSbGatsbyImageUrlFilters = (asset: StoryblokAsset, quality: number, fitIn: boolean, fitInColour: string): string => {
    const filters: string[] = [
        quality && `quality(${quality})`,
        fitIn && `fill(${fitInColour.replace('#', '')})`,
        asset.focus && `focal(${asset.focus})`,
    ].filter(Boolean);
    if (!filters.length) return '';
    return `/filters:${filters.join(':')}`;
}

export const getSbGatsbyImageUrl = (asset: StoryblokAsset, quality: number, fitIn: boolean, fitInColour: string, smartCrop: boolean, width?: number, height?: number): string => {
    let url: string = `${asset.filename}/m`;
    if (fitIn) url += '/fit-in';
    if (width || height) url += `/${width || 0}x${height || 0}`;
    if (smartCrop) url += '/smart';
    const filters: string = getSbGatsbyImageUrlFilters(asset, quality, fitIn, fitInColour);
    url += filters;
    if (url.endsWith('/m')) url += '/';
    return url;
}